import React, { FC } from 'react';
import { ReactComponent as SortingIcon } from 'src/assets/images/sorting-icon.svg';
import styled from 'styled-components';
import { Table, TH } from '../../../components/table/table';
import { IOrder } from '../../../graphql/types';
import { White } from '../../../styles/colours';
import { OrdersTableBody } from './table-body';

const StyledCustomerOrdersTable = styled(Table)`
  background-color: ${White};
  border-radius: 0.25rem;
`;

const SortingIconContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  padding: 0px svg {
    width: 18px;
    height: 16px;
    vertical-align: bottom;
    padding: 0px 0px 2px 0px;
  }
`;

interface ICustomerOrdersTableProps {
  orders: IOrder[];
}

interface ISortConfig {
  key: string;
  direction: 'descending' | 'ascending';
}

const OrdersTable: FC<ICustomerOrdersTableProps> = ({ orders }) => {
  const partnerInfo = orders.filter(order => order.partnerInfo);
  const sortedOrders = [...orders];
  const [sortConfig, setSortConfig] = React.useState<ISortConfig | null>(null);

  const setSorting = (key: string) => {
    if (sortConfig && sortConfig.direction === 'descending') {
      setSortConfig({ key, direction: 'ascending' });
    } else {
      setSortConfig({ key, direction: 'descending' });
    }
  };

  if (sortConfig !== null) {
    switch (sortConfig.key) {
      case 'createdOn': {
        sortConfig.direction === 'descending'
          ? sortedOrders.sort(
              (a, b) =>
                +new Date(b.createdOn + ' ' + b.createdAt) -
                +new Date(a.createdOn + ' ' + a.createdAt)
            )
          : sortedOrders.sort(
              (a, b) =>
                +new Date(a.createdOn + ' ' + a.createdAt) -
                +new Date(b.createdOn + ' ' + b.createdAt)
            );
        break;
      }
      case 'poID': {
        sortConfig.direction === 'descending'
          ? sortedOrders.sort((a, b) =>
              b.poID.localeCompare(a.poID, 'en', {
                ignorePunctuation: true,
                numeric: true,
              })
            )
          : sortedOrders.sort((a, b) =>
              a.poID.localeCompare(b.poID, 'en', {
                ignorePunctuation: true,
                numeric: true,
              })
            );
        break;
      }
      default: {
        sortConfig.direction === 'descending'
          ? sortedOrders.sort((a, b) => +b.id - +a.id)
          : sortedOrders.sort((a, b) => +a.id - +b.id);
      }
    }
  }

  return (
    <>
      <StyledCustomerOrdersTable>
        <thead>
          <tr>
            <TH align="left">
              Date created{' '}
              <SortingIconContainer>
                <SortingIcon onClick={() => setSorting('createdOn')} />
              </SortingIconContainer>
            </TH>
            <TH align="left">
              Shell order no.{' '}
              <SortingIconContainer>
                <SortingIcon onClick={() => setSorting('id')} />
              </SortingIconContainer>
            </TH>
            <TH align="left">
              Purchase Order no.{' '}
              <SortingIconContainer>
                <SortingIcon onClick={() => setSorting('poID')} />
              </SortingIconContainer>
            </TH>
            <TH align="left">Ship-to name</TH>
            <TH align="left"> {partnerInfo.length > 0 && 'Vessel details'}</TH>
            <TH align="left">Line items ordered</TH>
            <TH align="left">Status</TH>
            <TH align="left">Reject Status</TH>
          </tr>
        </thead>
        <OrdersTableBody orders={sortedOrders} />
      </StyledCustomerOrdersTable>
    </>
  );
};

export { OrdersTable };
